import React, {Component} from 'react';
import ReportContainer from "../../containers/report_container";
import {Form, Input} from 'semantic-ui-react';

const uuidv1 = require('uuid/v1');


class AddNewDataToReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: undefined
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.props.type === 'Room') {
            this.addNewRoomAtLast();
        }
        if (this.props.type === 'Group') {
            this.addNewGroupAtLast(this.props.roomIndex);
        }
        if (this.props.type === 'Item') {
            this.addNewItemAtLast(this.props.roomIndex, this.props.groupIndex);
        }
        this.refs.addNew.inputRef.value = '';
        this.setState({name: undefined});
    };
    addNewRoomAtLast = () => {
        if (this.props.reportId) {
            const addNewRoom = {
                client_id: uuidv1(),
                name: this.state.name,
                images: [],
                groups: [],
                additional_notes: "",
                action: 'create'
            };
            this.props.addNewRoomAtLast(addNewRoom);
        }
    };
    addNewGroupAtLast = (roomIndex) => {
        if (this.props.roomId) {
            const addNewGroup = {
                room_id: this.props.roomId,
                client_id: uuidv1(),
                name: this.state.name,
                images: [],
                items: [],
                action: 'create'
            };
            this.props.addNewGroupAtLast(roomIndex, addNewGroup);
        }
    };
    addNewItemAtLast = (roomIndex, groupIndex) => {
        this.props.newItemAdded(true);
        if (this.props.groupId) {
            const addNewItem = {
                group_id: this.props.groupId,
                client_id: uuidv1(),
                name: this.state.name,
                images: [],
                action: 'create',
                ci_notes: ""
            };
            this.props.addNewItemAtLast(roomIndex, groupIndex, addNewItem);
        }
    };

    render() {
        return (<Form onSubmit={this.handleSubmit}>
            {(this.props.reportDetails['inspection_type'] !== 'co' || (this.props.reportDetails["inspection_type"] ==="co" && this.props.other_template) ) && <div>
                <Form.Field width={16} className="report-inputs">
                    <Input fluid
                           label={"+ Add New " + this.props.type}
                           ref="addNew"
                           className="format-capitalize"
                           type='text'
                           maxLength="255"
                           placeholder={this.props.type + " Name"}
                           onChange={(e) => {
                               this.setState({name: e.target.value});
                           }}
                           required/>
                </Form.Field>
            </div>}
        </Form>);
    }

}

export default ReportContainer(AddNewDataToReport);


// WEBPACK FOOTER //
// ./src/views/report/add_new_data.js